// loginlink.js
// All the buttons and forms and modals and shit live in here

import React from 'react';
import { ButtonToolbar } from 'react-bootstrap';

import SignInButton from './SignInButton';
import SignUpButton from './SignUpButton';
import ForgottenPasswordEmailPrompt from './ForgottenPasswordEmail';
import NewPassword from './NewPassword';

const LoginLink = () => {
  return (
    <div className="nav navbar-header navbar-right">
      <ButtonToolbar>
        <SignInButton />
        <ForgottenPasswordEmailPrompt />
        <NewPassword />
        <SignUpButton />
      </ButtonToolbar>
    </div>
  );
};

export default LoginLink;



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/LoginLink.js